import React, { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Typography, Form, Button, Input } from 'antd';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';
import { apiPost } from 'helpers/ApiHelper';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Paragraph } = Typography;
const { TextArea } = Input;

const translate = (key) =>
  getTranslatedString(
    `landlordPortal.applicationManagement.applicationOverview.NotifyChangeToApplicants.${key}`
  );

const requiredField = {
  required: true,
  message: getTranslatedString('requiredField'),
  validateTrigger: 'onChange',
};

const NotifyChangeToApplicantsModal = ({ visible, onClose, onCancel, afterSubmit }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);
  const [notifyChangeToApplicantsForm] = Form.useForm();
  const message = Form.useWatch('message', notifyChangeToApplicantsForm);
  const queryClient = useQueryClient();
  const notifyChangeToApplicantsMutation = useMutation({
    mutationFn: (data) =>
      apiPost(
        `/landlords/application_management/applications/${application.id}/notify_changes`,
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['applications'] });
    },
    onError: () => message.error(getTranslatedString('unknownError')),

    onSettled() {
      notifyChangeToApplicantsForm.resetFields();
      afterSubmit();
    },
  });

  return (
    <Modal
      visible={visible}
      destroyOnClose
      title={translate('modal.title')}
      onCancel={onClose}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            notifyChangeToApplicantsForm.resetFields();
            onCancel();
          }}
        >
          {translate('modal.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={notifyChangeToApplicantsForm.submit}
          loading={notifyChangeToApplicantsForm.isLoading}
          disabled={!message}
        >
          {translate('modal.submit')}
        </Button>,
      ]}
    >
      <Paragraph>{translate('modal.text')}</Paragraph>
      <Form
        form={notifyChangeToApplicantsForm}
        layout="vertical"
        size={isMobile && 'large'}
        onFinish={notifyChangeToApplicantsMutation.mutate}
      >
        <Form.Item
          label={translate('modal.messageToApplicants')}
          name="message"
          rules={[requiredField]}
        >
          <TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};

NotifyChangeToApplicantsModal.defaultProps = {
  afterSubmit: () => {},
  onCancel: () => {},
};

export default NotifyChangeToApplicantsModal;
